(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-addon-carousel"] && !Shopify.designMode) return;
  try {
    class ProductAddonCarousel extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.track = this.querySelector('[data-addon-track]');
      this.navigation = this.querySelector('[data-addon-navigation]');
      this.previousButton = this.querySelector('[data-addon-prev]');
      this.nextButton = this.querySelector('[data-addon-next]');
      this.dots = this.querySelector('[data-addon-dots]');
      this.dialog = this.querySelector('[data-addon-dialog]');
      this.currentIndex = 0;
      this.isFreeActive = false;

      if (!this.track) return;

      this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1), { signal });
      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1), { signal });
      this.dots?.addEventListener('click', (event) => this.handleDotClick(event), { signal });
      this.track.addEventListener('scroll', () => this.handleScroll(), { passive: true, signal });
      this.addEventListener('click', (event) => this.handleClick(event), { signal });
      this.addEventListener('change', (event) => this.handleVariantChange(event), { signal });
      this.addEventListener('variant:add', (event) => this.handleProductAdded(event), { signal });

      if (this.dataset.freePromoEnabled === 'true') {
        this.setupPromoTracking(signal);
      }

      if (this.hasAttribute('data-dynamic-source')) {
        this.loadDynamicSlides();
      } else {
        this.initializeSlides();
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }

    setupPromoTracking(signal) {
      const refreshPromo = () => this.checkCartPromo();

      document.addEventListener('cart:refresh', refreshPromo, { signal });
      document.addEventListener('cart:updated', refreshPromo, { signal });
      document.addEventListener('cart:change', refreshPromo, { signal });
      document.addEventListener('theme:cart:refresh', refreshPromo, { signal });
      document.addEventListener('cart-drawer:refresh', refreshPromo, { signal });
      window.addEventListener('focus', refreshPromo, { signal });
    }

    shuffle(items) {
      const shuffled = [...items];
      for (let index = shuffled.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
      }
      return shuffled;
    }

    initializeSlides() {
      this.resizeObserver?.disconnect();
      let allSlides = Array.from(this.track.querySelectorAll('[data-addon-slide]'));

      if (this.dataset.excludeCurrent === 'true') {
        allSlides.forEach((slide) => {
          if (slide.dataset.productId === this.dataset.currentProductId) slide.remove();
        });
        allSlides = Array.from(this.track.querySelectorAll('[data-addon-slide]'));
      }

      if (this.hasAttribute('data-randomize')) {
        this.shuffle(allSlides).forEach((slide) => this.track.append(slide));
        allSlides = Array.from(this.track.querySelectorAll('[data-addon-slide]'));
      }

      const requestedLimit = Number.parseInt(this.dataset.limit, 10) || allSlides.length;
      allSlides.forEach((slide, index) => {
        slide.hidden = index >= requestedLimit;
      });
      this.slides = allSlides.filter((slide) => !slide.hidden);

      if (!this.slides.length) {
        this.remove();
        return;
      }

      this.prepareSlides();
      this.currentIndex = 0;
      this.renderDots();
      this.updateNavigation();
      this.resizeObserver = new ResizeObserver(() => this.goTo(this.currentIndex, 'auto'));
      this.resizeObserver.observe(this.track);
    }

    prepareSlides() {
      this.slides.forEach((slide) => {
        const infoButton = slide.querySelector('[data-product-info]');
        const moreInfo = slide.querySelector('.product-addon__more');
        const variantSelect = slide.querySelector('[data-variant-select]');
        const addButton = slide.querySelector('[data-add-button]');
        const currentPrice = slide.querySelector('[data-card-current-price]');
        const comparePrice = slide.querySelector('[data-card-compare-price]');

        if (!slide.dataset.defaultPrice && currentPrice) {
          slide.dataset.defaultPrice = currentPrice.textContent.trim();
        }
        if (!slide.dataset.defaultCompare && comparePrice) {
          slide.dataset.defaultCompare = comparePrice.hidden ? '' : comparePrice.textContent.trim();
        }

        if (infoButton) {
          if (this.dataset.moreInfoLabel) {
            infoButton.setAttribute('aria-label', `${this.dataset.moreInfoLabel}: ${infoButton.dataset.title || ''}`);
            if (moreInfo) moreInfo.textContent = this.dataset.moreInfoLabel;
          } else {
            infoButton.disabled = true;
            infoButton.removeAttribute('data-product-info');
            infoButton.classList.add('product-addon__info--static');
            if (moreInfo) moreInfo.hidden = true;
          }
        }

        if (variantSelect) variantSelect.hidden = this.dataset.showVariantSelector !== 'true';
        if (addButton && !addButton.disabled) addButton.textContent = this.dataset.buttonLabel || '';
      });

      if (this.dataset.freePromoEnabled === 'true') {
        this.checkCartPromo();
      }
    }

    async loadDynamicSlides() {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(`${root}search`, window.location.origin);
      url.searchParams.set('section_id', 'product-addon-search');
      url.searchParams.set('type', 'product');
      url.searchParams.set('q', `product_type:"${this.dataset.productType || ''}"`);

      if (this.dataset.inStockOnly === 'true') {
        url.searchParams.set('options[unavailable_products]', 'hide');
      }

      try {
        const response = await fetch(url, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) throw new Error('Unable to load product add-ons');

        const responseHtml = await response.text();
        const responseDocument = new DOMParser().parseFromString(responseHtml, 'text/html');
        const dynamicSlides = responseDocument.querySelector('[data-addon-dynamic-slides]');
        const slides = Array.from(dynamicSlides?.querySelectorAll('[data-addon-slide]') || []);

        if (!slides.length) {
          this.remove();
          return;
        }

        this.track.replaceChildren(...slides.map((slide) => document.importNode(slide, true)));
        this.initializeSlides();
      } catch (error) {
        this.remove();
      }
    }

    async checkCartPromo() {
      if (this.dataset.freePromoEnabled !== 'true') return;

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin',
        });
        if (!response.ok) return;
        const cart = await response.json();

        const matchingProductIds = new Set();
        const allSlides = this.track?.querySelectorAll('[data-addon-slide]') || [];
        allSlides.forEach((slide) => {
          if (slide.dataset.productId) matchingProductIds.add(String(slide.dataset.productId));
        });

        const targetType = (this.dataset.productType || '').trim().toLowerCase();

        let matchingUnits = 0;
        (cart.items || []).forEach((item) => {
          const itemProductId = String(item.product_id);
          const itemType = (item.product_type || '').trim().toLowerCase();

          if (matchingProductIds.has(itemProductId) || (targetType && itemType === targetType)) {
            matchingUnits += Number.parseInt(item.quantity, 10) || 0;
          }
        });

        this.updatePricingState(matchingUnits);
      } catch (err) {
        // Silently continue
      }
    }

    updatePricingState(matchingUnits = 0) {
      if (this.dataset.freePromoEnabled !== 'true') return;

      const limit = Number.parseInt(this.dataset.freeItemsLimit, 10) || 2;
      const isFree = matchingUnits < limit;
      const freeText = this.dataset.freePriceText || 'Gratis';
      const showCompareWhenFree = this.dataset.showCompareWhenFree === 'true';

      this.isFreeActive = isFree;

      this.slides?.forEach((slide) => {
        const select = slide.querySelector('[data-variant-select]');
        const selectedOption = select ? select.selectedOptions[0] : null;

        const basePrice = selectedOption ? selectedOption.dataset.price : (slide.dataset.defaultPrice || '');
        const baseCompare = selectedOption ? selectedOption.dataset.comparePrice : (slide.dataset.defaultCompare || '');

        const priceEl = slide.querySelector('[data-card-current-price]');
        const compareEl = slide.querySelector('[data-card-compare-price]');
        const infoBtn = slide.querySelector('[data-product-info]');

        if (isFree) {
          if (priceEl) {
            priceEl.textContent = freeText;
            priceEl.classList.add('product-addon__new--free');
          }
          if (compareEl) {
            if (showCompareWhenFree && basePrice) {
              compareEl.textContent = basePrice;
              compareEl.hidden = false;
            } else {
              compareEl.textContent = '';
              compareEl.hidden = true;
            }
          }
          if (infoBtn) {
            infoBtn.dataset.displayPrice = freeText;
            infoBtn.dataset.displayCompare = showCompareWhenFree ? (basePrice || '') : '';
          }
        } else {
          if (priceEl) {
            priceEl.textContent = basePrice || '';
            priceEl.classList.remove('product-addon__new--free');
          }
          if (compareEl) {
            compareEl.textContent = baseCompare || '';
            compareEl.hidden = !baseCompare;
          }
          if (infoBtn) {
            infoBtn.dataset.displayPrice = basePrice || '';
            infoBtn.dataset.displayCompare = baseCompare || '';
          }
        }
      });

      if (this.dialog?.open && this.currentActiveInfo) {
        const price = this.dialog.querySelector('[data-dialog-price]');
        const comparePrice = this.dialog.querySelector('[data-dialog-compare]');
        const displayPrice = this.currentActiveInfo.dataset.displayPrice || this.currentActiveInfo.dataset.infoPrice || '';
        const displayCompare = this.currentActiveInfo.dataset.displayCompare !== undefined
          ? this.currentActiveInfo.dataset.displayCompare
          : (this.currentActiveInfo.dataset.infoComparePrice || '');

        if (price) price.textContent = displayPrice;
        if (comparePrice) {
          comparePrice.textContent = displayCompare;
          comparePrice.hidden = !displayCompare;
        }
      }
    }

    renderDots() {
      if (!this.dots) return;
      this.dots.replaceChildren();

      this.slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-addon__dot';
        dot.dataset.addonDot = index;
        dot.setAttribute('aria-label', (this.dataset.dotLabel || '').replace('__INDEX__', index + 1));
        dot.setAttribute('aria-controls', slide.id || '');
        this.dots.append(dot);
      });
    }

    handleDotClick(event) {
      const dot = event.target.closest('[data-addon-dot]');
      if (!dot) return;
      this.goTo(Number.parseInt(dot.dataset.addonDot, 10));
    }

    handleScroll() {
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => {
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - this.track.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.currentIndex = closestIndex;
        this.updateNavigation();
      });
    }

    goTo(index, behavior = 'smooth') {
      if (!this.slides.length) return;
      this.currentIndex = Math.max(0, Math.min(this.slides.length - 1, index));
      this.track.scrollTo({ left: this.slides[this.currentIndex].offsetLeft, behavior });
      this.updateNavigation();
    }

    updateNavigation() {
      if (this.navigation) this.navigation.hidden = this.slides.length <= 1;
      if (this.previousButton) this.previousButton.disabled = this.currentIndex === 0;
      if (this.nextButton) this.nextButton.disabled = this.currentIndex >= this.slides.length - 1;

      this.dots?.querySelectorAll('[data-addon-dot]').forEach((dot, index) => {
        dot.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');
      });
    }

    handleClick(event) {
      const closeButton = event.target.closest('[data-dialog-close]');
      if (closeButton) {
        this.dialog?.close();
        return;
      }

      if (event.target === this.dialog) {
        this.dialog.close();
        return;
      }

      const infoButton = event.target.closest('[data-product-info]');
      if (!infoButton || !this.dialog) return;

      this.currentActiveInfo = infoButton;

      const image = this.dialog.querySelector('[data-dialog-image]');
      const title = this.dialog.querySelector('[data-dialog-title]');
      const description = this.dialog.querySelector('[data-dialog-description]');
      const price = this.dialog.querySelector('[data-dialog-price]');
      const comparePrice = this.dialog.querySelector('[data-dialog-compare]');

      const displayPrice = infoButton.dataset.displayPrice || infoButton.dataset.infoPrice || '';
      const displayCompare = infoButton.dataset.displayCompare !== undefined
        ? infoButton.dataset.displayCompare
        : (infoButton.dataset.infoComparePrice || '');

      title.textContent = infoButton.dataset.title || '';
      price.textContent = displayPrice;
      comparePrice.textContent = displayCompare || '';
      comparePrice.hidden = !displayCompare;
      description.textContent = infoButton.dataset.description || '';
      description.hidden = !infoButton.dataset.description;

      if (infoButton.dataset.image) {
        image.src = infoButton.dataset.image;
        image.alt = infoButton.dataset.title || '';
        image.hidden = false;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        image.hidden = true;
      }

      this.dialog.showModal();
    }

    handleVariantChange(event) {
      const select = event.target.closest('[data-variant-select]');
      if (!select) return;

      const slide = select.closest('[data-addon-slide]');
      const card = select.closest('.product-addon__card');
      const selectedOption = select.selectedOptions[0];
      const price = card.querySelector('[data-card-current-price]');
      const comparePrice = card.querySelector('[data-card-compare-price]');
      const addButton = card.querySelector('[data-add-button]');
      const infoButton = card.querySelector('[data-product-info]');
      const available = selectedOption?.dataset.available === 'true';

      const regularPrice = selectedOption?.dataset.price || '';
      const regularCompare = selectedOption?.dataset.comparePrice || '';

      if (slide) {
        slide.dataset.defaultPrice = regularPrice;
        slide.dataset.defaultCompare = regularCompare;
      }

      if (this.dataset.freePromoEnabled === 'true' && this.isFreeActive) {
        const freeText = this.dataset.freePriceText || 'Gratis';
        const showCompareWhenFree = this.dataset.showCompareWhenFree === 'true';

        if (price) {
          price.textContent = freeText;
          price.classList.add('product-addon__new--free');
        }
        if (comparePrice) {
          if (showCompareWhenFree && regularPrice) {
            comparePrice.textContent = regularPrice;
            comparePrice.hidden = false;
          } else {
            comparePrice.textContent = '';
            comparePrice.hidden = true;
          }
        }
        if (infoButton) {
          infoButton.dataset.infoPrice = regularPrice;
          infoButton.dataset.infoComparePrice = regularCompare;
          infoButton.dataset.displayPrice = freeText;
          infoButton.dataset.displayCompare = showCompareWhenFree ? regularPrice : '';
        }
      } else {
        if (price) {
          price.textContent = regularPrice;
          price.classList.remove('product-addon__new--free');
        }
        if (comparePrice) {
          comparePrice.textContent = regularCompare;
          comparePrice.hidden = !regularCompare;
        }
        if (infoButton) {
          infoButton.dataset.infoPrice = regularPrice;
          infoButton.dataset.infoComparePrice = regularCompare;
          infoButton.dataset.displayPrice = regularPrice;
          infoButton.dataset.displayCompare = regularCompare;
        }
      }

      addButton.disabled = !available;
      addButton.textContent = available ? this.dataset.buttonLabel : this.dataset.soldOutLabel;
    }

    handleProductAdded(event) {
      const form = event.target.closest('form');
      const status = form?.querySelector('[data-add-status]');
      if (status) {
        status.textContent = this.dataset.addedLabel || '';
        clearTimeout(status.clearTimer);
        status.clearTimer = setTimeout(() => {
          status.textContent = '';
        }, 2200);
      }

      if (this.dataset.freePromoEnabled === 'true') {
        setTimeout(() => this.checkCartPromo(), 350);
        setTimeout(() => this.checkCartPromo(), 900);
      }
    }
  }

  if (!customElements.get('product-addon-carousel')) {
    customElements.define('product-addon-carousel', ProductAddonCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
